module.exports = __webpack_public_path__ + "img/地址.ce21adfd.png";